<div class="form-group">
    <label class="control-label col-sm-2">Flat Storage</label>
    <div class="col-sm-10 form-control-static">{{ treatmentDetail.flatStorageFacilityType }} {{ treatmentDetail.flatStorageFacilityLocation }}</div>
</div>

<div class="form-group">
    <label class="control-label col-sm-2">Automation Pots</label>
    <div class="col-sm-10 form-control-static">{{ treatmentDetail.automationPotStorageFacilityType }} {{ treatmentDetail.automationPotStorageLocation }}</div>
</div>

<div class="form-group">
    <label class="control-label col-sm-2">Static Pots</label>
    <div class="col-sm-10 form-control-static">{{ treatmentDetail.staticPotStorageFacilityType }} {{ treatmentDetail.staticPotStorageLocation }}</div>
</div>

<div class="panel panel-default" *ngFor="let treatmentDetailComment of treatmentDetail.comments">
    <div class="panel-heading">
        <h2 class="panel-title">{{ treatmentDetailComment.instructionType | instructionTypeName }} - {{ treatmentDetailComment.instructionSubtype | instructionSubtypeName }}</h2>
    </div>

    <div class="panel-body">
        {{ treatmentDetailComment.comment }}
    </div>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/review-request/planning-treatment-detail/planning-treatment-detail.component.html